import { render } from "./CategoryCardsComponent.vue?vue&type=template&id=261b1922"
import script from "./CategoryCardsComponent.vue?vue&type=script&lang=js"
export * from "./CategoryCardsComponent.vue?vue&type=script&lang=js"

import exportComponent from "/home/adrian/Proyectos/eunoia_travel/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__